"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../utils/utils");

var _InputConstants = require("./InputConstants");

require("./Text.less");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var InputText = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(InputText, _Component);

  var _super = _createSuper(InputText);

  function InputText(props) {
    var _this;

    (0, _classCallCheck2.default)(this, InputText);
    _this = _super.call(this, props);
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      value: _this.props.value || '',
      isDirty: false,
      isValid: false,
      validityClass: '',
      invalidReasons: []
    };
    return _this;
  }

  (0, _createClass2.default)(InputText, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value != this.props.value) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      var _this2 = this;

      this.validate();
      this.setState({
        value: this.state.value.trim()
      }, function () {
        _this2.props.onBlur(e);
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(value) {
      var _this3 = this;

      this.setState({
        value: value,
        isDirty: true
      }, function () {
        _this3.props.onChange(value);
      });
    }
  }, {
    key: "validate",
    value: function validate() {
      var value = this.state.value;
      var invalidReasons = [];

      if (value && value.length > 0 || this.props.required) {
        if (this.props.required && value.trim().length == 0) {
          invalidReasons.push('Field is required.');
        }

        if (value.length > parseInt(this.props.maxLength)) {
          invalidReasons.push("Cannot exceed ".concat(this.props.maxLength, " characters."));
        }

        if (value.length < parseInt(this.props.minLength)) {
          invalidReasons.push("Must be at least ".concat(this.props.maxLength, " characters."));
        }

        if (this.props.validator == _InputConstants.VALIDATORS.ALPHA && value.match(/^[A-Za-z]+$/) == null) {
          invalidReasons.push('May only contain letters.');
        }

        if (this.props.validator == _InputConstants.VALIDATORS.NUMERIC && isNaN(value)) {
          invalidReasons.push('May only contain alphabetic characters, [A-Z]');
        }
      }

      var validityClass = '';

      if (!this.props.hideValidation) {
        validityClass = invalidReasons.length > 0 ? _InputConstants.CLASSES.STATUS.INVALID : _InputConstants.CLASSES.STATUS.VALID;
      }

      this.setState({
        isValid: invalidReasons.length == 0,
        validityClass: validityClass,
        invalidReasons: invalidReasons
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var className = this.props.className;
      return /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
        className: "".concat(_InputConstants.CLASSES.TYPE.TEXT, " ").concat(this.state.validityClass, " ").concat(this.props.size, " ").concat(className),
        type: "text",
        value: this.state.value,
        onBlur: function onBlur(e) {
          _this4.handleBlur(e.target.value);
        },
        onChange: function onChange(e) {
          _this4.handleChange(e.target.value);
        }
      }, (0, _utils.omit)(this.props, ['className', 'type', 'value', 'onBlur', 'onChange', 'validator', 'hideValidation'])));
    }
  }], [{
    key: "propTypes",
    value: function propTypes() {
      return {
        id: _propTypes.default.string,
        placeholder: _propTypes.default.any,
        className: _propTypes.default.string,
        size: _propTypes.default.oneOf(['smallest', 'small', '', 'large']),
        validator: _propTypes.default.oneOf(_InputConstants.VALIDATORS),
        required: _propTypes.default.bool,
        minLength: _propTypes.default.string,
        maxLength: _propTypes.default.string,
        value: _propTypes.default.string,
        onBlur: _propTypes.default.func,
        onChange: _propTypes.default.func
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        id: '',
        className: '',
        value: '',
        size: '',
        required: false,
        validator: _InputConstants.VALIDATORS.NONE,
        minLength: '',
        maxLength: '',
        onChange: function onChange() {},
        onBlur: function onBlur() {}
      };
    }
  }]);
  return InputText;
}(_react.Component);

exports.default = InputText;